function RewardRedemptionError(props) {
    return (
        <div className={"flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0" + (props.descriptionLength ? " ml-[250px]" : " self-baseline")}>
            <div className="flex justify-start items-start flex-grow overflow-hidden gap-2 pr-4 rounded">
                <div className="flex justify-start items-start flex-grow-0 flex-shrink-0 relative gap-2">
                    <svg
                        width={24}
                        height={25}
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 3.25L2 20.5705H22L12 3.25ZM12 6.80292L5.07692 18.794H18.9231L12 6.80292Z"
                            fill="#FF3B30"
                        />
                        <path
                            d="M11.2466 10.044C11.0822 10.2401 11 10.4804 11 10.7649C11 11.0495 11.0822 11.2866 11.2466 11.4763C11.417 11.666 11.6667 11.7608 11.9954 11.7608C12.3242 11.7608 12.5738 11.666 12.7443 11.4763C12.9148 11.2866 13 11.0495 13 10.7649C13 10.4804 12.9148 10.2401 12.7443 10.044C12.5738 9.84801 12.3242 9.75 11.9954 9.75C11.6667 9.75 11.417 9.84801 11.2466 10.044Z"
                            fill="#FF3B30"
                        />
                        <path d="M12.9949 17.2791H10.9929V13.2369H12.9949V17.2791Z" fill="#FF3B30" />
                    </svg>
                </div>
                <div className="flex flex-col justify-start items-start flex-grow relative gap-1">
                    <p className="self-stretch flex-grow-0 flex-shrink-0 w-[303px] text-sm text-left text-black">
                        {props.redemptionErrorMessage}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default RewardRedemptionError;
